<template>
  <base-modal hide-header hide-footer @close="close"  >
    <div  @click.stop="">
        <h3 class="editor-header">
          {{ $t('orders.order_price_history_title') }}
        </h3>
      <div class="col-sm-12 nopads">
        <Transition name="fade">
          <div v-if="tableItems.length > 0" class="col-sm-12 pb-2 result-table">
              <vue3-datatable
                  :rows="tableItems"
                  :columns="fields"
                  :pagination="false"
                  :sticky-header="true"
                  :height="tableItems.length > 5 ? '40vh' : '100%'"
                  :sortable="true"
                  skin="bh-table-compact"
                  row-class="routa-table-row"
                  cell-class="routa-table-cell"
              >
                  <template #price_list="data">
                      {{ data.value.price_list ? data.value.price_list.name : null }}
                  </template>
                  <template #unit_price="data">
                      {{ data.value.unit_price ? (data.value.unit_price / 100).toFixed(3) : null }}
                  </template>
                  <template #pricing_model="data">
                      {{ pricingModelToText(data.value.pricing_model) }}
                  </template>
                  <template #created_by="data">
                      {{ data.value.created_by ? data.value.created_by.first_name + " " + data.value.created_by.last_name : null }}
                  </template>
                  <template #removed_by="data">
                      {{ data.value.removed_by ? data.value.removed_by.first_name + " " + data.value.removed_by.last_name : null }}
                  </template>
                  <template #created_date="data">
                      {{ data.value.created_date ? timestampToDateInput(data.value.created_date) : null }}
                  </template>
                  <template #cell(removed_date)="data">
                      {{ data.value.removed_date ? timestampToDateInput(data.value.removed_date) : null }}
                  </template>
              </vue3-datatable>
          </div>
        </Transition>
      </div>
      <div class="col-12 text-end my-2">
        <button class="btn btn-secondary form-button" @click.stop="close">
          {{ $t('common.close') }}
        </button>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </base-modal>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {priceHelper} from "@/components/mixins/PricingMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import Vue3Datatable from '@bhplugin/vue3-datatable'
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: "OrderPriceHistoryModal",
    components: {BaseModal, Vue3Datatable},
    mixins: [restApi, priceHelper, timeUtils],
    props: {
        orderId: {
            type: Number,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            priceHistories: [],
            tableItems: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: 'Id', sort: true, type: 'number'},
                {field: 'unit_price', title: this.$t('orders.unit_price', {currency: import.meta.env.VITE_APP_CURRENCY}), sort: true, headerClass: 'routa-table-header'},
                {field: 'pricing_model', title: this.$t('orders.pricing_model'), sort: true, headerClass: 'routa-table-header'},
                {field: 'price_list', title: this.$t('orders.pricelist'), sort: true, headerClass: 'routa-table-header'},
                {field: 'created_date', title: this.$t('orders.create_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'removed_date', title: this.$t('orders.complete_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'created_by', title: this.$t('orders.created_by'), sort: true, headerClass: 'routa-table-header'},
                {field: 'removed_by', title: this.$t('orders.removed_by'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    mounted() {
        this.fetchPriceHistory()
    },
    methods: {
        fetchPriceHistory() {
            this.loading = true
            this.priceHistories = []
            this.restFetch(this.orderPriceHistoryUrl + "/" + this.orderId, this.successPriceHistory, this.failPriceHistory)
        },
        successPriceHistory(response) {
            this.loading = false
            if(response && response.data) {
                this.priceHistories = response.data
            }
            this.initTableItems()
        },
        initTableItems() {
            this.tableItems = []
            const temp = []
            if (this.priceHistories) {
                this.priceHistories.forEach(item => {
                    temp.push(item)
                })
            }
            this.$nextTick(() => this.tableItems = temp)
        },
        failPriceHistory() {
            this.loading = false
            this.showAlert(this.$t('common.error'))
        },
        close() {
            this.$emit("close")
        },
    }
}
</script>
<style>
.prop-header {
    font-weight: 800;
    font-size: 0.8em;
    text-transform: uppercase;
}
</style>
